import React, { useMemo } from 'react';
import BillingActionsNeededSection from '../components/billing-dashboard/billing-actions-needed-section';
import {
  mapBillingDashboardApiToOverview,
  mapOutstandingInvoiceApiToRow,
} from '../components/billing-dashboard/billing-dashboard-api-map';
import { mapBillingNeededActionToUi } from '../components/billing-dashboard/needed-actions-map';
import BillingFinancialOverviewSection from '../components/billing-dashboard/billing-financial-overview-section';
import BillingPastDueInvoicesSection from '../components/billing-dashboard/billing-past-due-invoices-section';
import {
  useGetBillingDashboardQuery,
  useGetBillingNeededActionsQuery,
  useGetBillingOutstandingInvoicesQuery,
} from 'src/redux/billing/billing.endpoints';
import { EMPTY_BILLING_DASHBOARD_API_ITEM } from 'src/redux/billing/billing.types';

const BillingTab: React.FC = () => {
  const { data: neededActionsRaw } = useGetBillingNeededActionsQuery();
  const { data: dashboardRaw, isError: isDashboardError } = useGetBillingDashboardQuery();
  const { data: outstandingRaw } = useGetBillingOutstandingInvoicesQuery();

  const neededActionsUi = useMemo(
    () => (neededActionsRaw ?? []).map(mapBillingNeededActionToUi),
    [neededActionsRaw]
  );

  const pastDueRows = useMemo(
    () => (outstandingRaw ?? []).map(mapOutstandingInvoiceApiToRow),
    [outstandingRaw]
  );

  const overdueTotal = useMemo(
    () => pastDueRows.reduce((sum, row) => sum + row.amount, 0),
    [pastDueRows]
  );

  const overview = useMemo(
    () =>
      mapBillingDashboardApiToOverview(
        dashboardRaw ?? EMPTY_BILLING_DASHBOARD_API_ITEM,
        overdueTotal
      ),
    [dashboardRaw, overdueTotal]
  );

  return (
    <div className="flex h-full min-h-0 flex-col">
      {/* Full-bleed within layout padding; strip touches horizontal edges of main column */}
      <BillingActionsNeededSection items={neededActionsUi} />
      <div className="min-h-0 flex-1 overflow-auto pr-1">
        <div className="mx-auto flex max-w-6xl flex-col gap-6 pb-8 pt-4">
          {isDashboardError ? (
            <p className="text-sm text-red-700">
              Billing overview could not be loaded. Charts and metrics may be incomplete.
            </p>
          ) : null}
          <BillingFinancialOverviewSection overview={overview} />
          <BillingPastDueInvoicesSection pastDue={pastDueRows} />
        </div>
      </div>
    </div>
  );
};

export default BillingTab;
